"use client";

import { FunctionComponent, PropsWithChildren } from "react";
import { Label } from "../../label/label";
import { Body, Description, InlineError, Wrapper } from "./field-container.styles";

export interface FieldContainerProps {
    /**
     * Children of the field.
     */
    children: React.ReactNode;

    /**
     * ID of the field.
     */
    id?: string;

    /**
     * Label of the field.
     */
    label?: string;

    /**
     * Secondary label of the field. Only applied if `label` isset.
     */
    secondaryLabel?: string;

    /**
     * Desciption of the field.
     */
    description?: string;

    /**
     * Hide the label of the field.
     */
    hideLabel?: boolean | false;

    /**
     * Will open a tooltip on hover the label. Only applied if `label` isset.
     */
    tooltip?: string;

    /**
     * Mark the field as required.
     */
    required?: boolean | false;

    /**
     * Error message.
     */
    error?: string;

    /**
     * Class name of the field container.
     */
    className?: string;
}

export const FieldContainer: FunctionComponent<PropsWithChildren<FieldContainerProps>> = ({
    error,
    children,
    label,
    secondaryLabel,
    description,
    hideLabel,
    id,
    tooltip,
    required,
    className,
}) => {
    return (
        <Wrapper className={className}>
            {label && !hideLabel && <Label label={label} id={id} tooltip={tooltip} required={required} />}
            {label && !hideLabel && secondaryLabel && <Label label={secondaryLabel} id={id} />}
            <Body>{children}</Body>
            {description && (
                <Description>
                    <label htmlFor={id}>{description}</label>
                </Description>
            )}
            {error && (
                <InlineError>
                    <label htmlFor={id}>{error}</label>
                </InlineError>
            )}
        </Wrapper>
    );
};
